<template>
  <div>
    <div v-show="!submitted">
      <div class="alert alert-danger" v-show="errorMessage">{{errorMessage}}</div>
      <br>
      <div class='row'>
          <div class="col-md-6 offset-md-3 col-xs-12">Dear {{dm.ministryRequest.candidateName}},</div>
      </div>
      <div class="row my-2">
        
        <div class="col-md-6 offset-md-3 col-xs-12" v-html="dm.message"></div>
      </div>
      <br>
    </div>
    <div v-show="submitted">
      <br>
      <br>
      <p>Thank you. Your response is received.</p>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      dm: {},
      showReason: false,
      reason: "",
      errorMessage: "",
      submitted: false, 
      status:""
    };
  },
  methods: {
    getDirectMessage: async function() {
      var id = this.$route.query.id;

      try {
        var response = await http.get("/directmessage/id/" + id);
        this.dm = response.data;
        this.dm.message = this.dm.message.replace("\n\n", "<br><br>")
      } catch (err) {
        console.error(err);
        alert(
          "Unable to fetch information. Please reload the page and try again."
        );
      }
    },
    submit: async function() {
      console.log('check', this.status, this.reason.length);
      if (this.status !== "Pending Interview / Audition" && this.reason.length == 0) {
        this.errorMessage = "Your reason(s) is required";
        return;
      }
      try {
        let data = {
          status: this.status
        };
        if (this.reason.length > 0) {
          data.reason = this.reason;
        }
        let response = await http.patch("/directmessage/" + this.dm.id, data);
        this.errorMessage = "";
        this.submitted = true;
      } catch (err) {
        console.log("accept err", err);
      }
    },
    inputReason: async function(status) {
      this.showReason = true;
      this.status = status;
    }
  },
  beforeMount: function() {
    this.submitted = false;
    this.getDirectMessage();
  }
};
</script>

<style>
</style>
